<modal [name]="localStorageKeys.ti_modal_prompt" [minWidth]="450" [maxWidth]="maxWidth" (closeOut)="buttonClick(DialogWindowResponse.no)">
  <modal-header>
    <span [ngClass]="['title', titleClass, titleColorByThemeColor()]">{{ title }}<span *ngIf="titleSuffix" class="title-suffix"> {{ titleSuffix }}</span></span>
  </modal-header>
  <modal-body>
    <form novalidate>
      <div class="control">
        <div *ngIf="text" [class]="textClass + ' text'" [innerHTML]="text"></div>
        <label [class.required]="required" for="prompt-dialog-input">{{label}}</label>

        <ng-container [ngSwitch]="inputType">

          <ng-container *ngSwitchCase="'textarea'">
            <textarea id="prompt-dialog-input" kendoTextArea class="k-textarea" name="textareaField" (keyup)="validateField(field)" [(ngModel)]="value" [title]="label" #field="ngModel"></textarea>

            <div class="error-message" *ngIf="field && field.hasError('maxlength')">{{errorMaxLengthMessage}}</div>
            <div class="error-message" *ngIf="field && field.hasError('errorText')">{{errorMessage}}</div>
          </ng-container>

          <ng-container *ngSwitchCase="'input'">
            <kendo-textbox
              id="prompt-dialog-input"
              name="inputField"
              [required]="required"
              [(ngModel)]="value"
              [title]="label"
              (keyup)="validateField(field)"
              #field="ngModel"
            ></kendo-textbox>

            <div class="error-message" *ngIf="field && field.hasError('maxlength')">{{errorMaxLengthMessage}}</div>
            <div class="error-message" *ngIf="field && field.hasError('errorText')">{{errorMessage}}</div>
          </ng-container>
        </ng-container>
      </div>
    </form>
  </modal-body>
  <modal-actions>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="buttonClick(DialogWindowResponse.no)">{{btnCancelTitle || strings.cancel}}</button>
    @if (modernBehavior()) {
      <div [tiTooltip] tooltipClass="k-tooltip-light"
           [tooltipTemplate]="isDisabled ? confirmButtonTempl : null"
           [filter]="'.k-button'" [showOn]="'hover'" [position]="'top'">
        <button kendoButton fillMode="solid" [themeColor]="themeColor ?? 'primary'"
                (click)="buttonClick(DialogWindowResponse.yes)">{{btnOkTitle || strings.ok }}</button>
      </div>
      <ng-template #confirmButtonTempl>
        <div class="action-confirm__tooltip__wrapper">
          <i class="fa-solid fa-exclamation-triangle action-confirm__tooltip--icon"></i>
          <span class="action-confirm__tooltip--text">{{ strings.pleaseFillInRequiredField }}</span>
        </div>
      </ng-template>
    } @else {
      <button kendoButton fillMode="solid" [themeColor]="themeColor ?? 'primary'"
              [disabled]="isDisabled"
              (click)="buttonClick(DialogWindowResponse.yes)">{{btnOkTitle || strings.ok }}</button>
    }
  </modal-actions>
</modal>

<ti-spinner *ngIf="isLoading"></ti-spinner>
